// Port of chart.coffee:77-82 — builds traitValues from trait for getTotalPickedUpAnswer/getBatches.

import { encodeLabel } from '@aytm/app/stats/lib/util/helpers'

// The name is plain registry text, and it ends up in batch texts and table titles that draw as
// markup, so it is encoded here once.
export const getTraitValues = trait => {
  if (!trait) return []
  const source = trait.values || trait.answerVariants || []
  return source.map(value => {
    // INTENTIONAL fix of coffee edge-case: `id: 0` falls through coffee's chained `&& / ||`
    // (chart.coffee:78-82). The ternary below preserves `id: 0`.
    // (`name: ''` and `[]` fallbacks remain parity-equivalent with coffee.)
    const id = Object.hasOwn(value, 'id') ? value.id : Object.hasOwn(value, 'position') ? `a${value.position}` : value
    const name = Object.hasOwn(value, 'name')
      ? encodeLabel(value.name?.en || value.name)
      : Object.hasOwn(value, 'position')
        ? `A${value.position}`
        : value
    return { id, name }
  })
}
